import Logo from "assets/Logo.png";
import jsPDF from "jspdf";
import { jsPDFDocument } from "jspdf-autotable";

export const addLogoToPdf = (pdf: jsPDF) => {
  pdf.addImage(Logo, "png", 30, 20, 80, 18.95);
};

export const getPdfSizes = (pdf: jsPDF) => {
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  return {
    pageHeight,
    pageWidth
  };
};

export const addQRatAfterTable = (
  pdf: jsPDF,
  qrId: string,
  { width, height }: { width: number; height: number }
) => {
  const { pageHeight, pageWidth } = getPdfSizes(pdf);

  const qrCanvas = document.getElementById(qrId) as HTMLCanvasElement;

  const base64Image = qrCanvas.toDataURL();

  const xQrPos = (pageWidth - width) / 2;

  const spaceBetweenTableAndQr = 12;

  if (
    (pdf as jsPDFDocument).lastAutoTable.finalY +
      height +
      spaceBetweenTableAndQr >
    pageHeight
  ) {
    pdf.addPage();
    pdf.addImage(base64Image, "png", xQrPos, 36, width, height);
  } else {
    pdf.addImage(
      base64Image,
      "png",
      xQrPos,
      (pdf as jsPDFDocument).lastAutoTable.finalY + spaceBetweenTableAndQr,
      width,
      height
    );
  }
};
